import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs2/helpers/objectWithoutProperties';
import { forwardRef, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import styledSystemPropTypes from '@styled-system/prop-types';
import { compose, background, border, color, flexbox, grid, layout, position, shadow, space, typography } from 'styled-system';
import { prop } from 'styled-tools';
import { jsxs, jsx } from 'react/jsx-runtime';

const _excluded = ["spinnerColor", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Spinner = styled.div.withConfig({
  displayName: "loading-indicator__Spinner",
  componentId: "sc-1v788nf-0"
})(["display:inline-block;width:", "px;height:", "px;position:relative;& div{box-sizing:border-box;display:block;position:absolute;width:100%;height:100%;border:", "px solid;border-radius:50%;animation:spin 1.2s cubic-bezier(0.5,0,0.5,1) infinite;border-color:", " transparent transparent transparent;}div:nth-child(1){animation-delay:-0.45s;}div:nth-child(2){animation-delay:-0.3s;}div:nth-child(3){animation-delay:-0.15s;}@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}", ";"], _ref => {
  let {
    sizeProps
  } = _ref;
  return sizeProps.width;
}, _ref2 => {
  let {
    sizeProps
  } = _ref2;
  return sizeProps.width;
}, _ref3 => {
  let {
    sizeProps
  } = _ref3;
  return sizeProps.borderWidth;
}, prop('spinnerColor'), compose(background, border, color, flexbox, grid, layout, position, shadow, space, typography));
const sizesList = {
  lg: {
    width: 64,
    borderWidth: 8
  },
  sm: {
    width: 40,
    borderWidth: 6
  },
  xxsm: {
    width: 16,
    borderWidth: 1
  }
};
const LoadingIndicator = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      spinnerColor,
      size
    } = props,
    omittedProps = _objectWithoutProperties(props, _excluded);
  const themeContext = useContext(ThemeContext);
  return /*#__PURE__*/jsxs(Spinner, _objectSpread(_objectSpread({
    ref: ref,
    sizeProps: sizesList[size],
    spinnerColor: spinnerColor || themeContext.colors.primary || '#999'
  }, omittedProps), {}, {
    children: [/*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {})]
  }));
});
LoadingIndicator.displayName = 'Loading Indicator';
LoadingIndicator.defaultProps = {
  'data-cy': 'LoadingIndicator',
  // component name
  size: 'lg'
};
LoadingIndicator.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.flexbox), styledSystemPropTypes.grid), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  spinnerColor: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'sm', 'xxsm'])
});

export default LoadingIndicator;
